import NewDesign from 'components/NewDesign';
import React from 'react';
import Props from '../../Components/Props';
import JSXCode from '../../Components/JSXCode';

const TabButton = () => {
  return (
    <div className='component:TabButton'>
      <div className='tw-flex tw-gap-2 tw-flex-wrap'>
        <NewDesign.Button variant='default'>Variant: default</NewDesign.Button>
        <NewDesign.Button variant='secondary'>Variant: secondary</NewDesign.Button>
        <NewDesign.Button variant='destructive'>Variant: destructive</NewDesign.Button>
        <NewDesign.Button variant='ghost'>Variant: ghost</NewDesign.Button>
        <NewDesign.Button variant='link'>Variant: link</NewDesign.Button>
        <NewDesign.Button variant='outline'>Variant: outline</NewDesign.Button>
      </div>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<NewDesign.Button
        onClick={() => {}}
        variant={"default"}
        className=""
        isLoading={false}
        style={{}}
>
        Button
</NewDesign.Button>`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'variant',
            type: `"default" | "destructive" | "outline" | "secondary" | "ghost" | "link"`,
            default: 'default',
          },
          {
            prop: 'onClick',
            type: 'func',
            default: 'undefined',
          },
          {
            prop: 'style',
            type: 'object',
            default: 'undefined',
          },
          {
            prop: 'className',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'isLoading',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabButton;
